@if (Zone) {
<div class="container-fluid mt-3 ">
    <div class="row rounded-1 background-light mb-3 py-3">
        <div class="col fw-bold text-center mb-3">
            Liste des PSV
        </div>
        <div class="row">
            @for (sp of getUniquePSV(); track sp) {
            <div class="col-6 text-center">
                {{sp.Name}}
            </div>
            }
        </div>
    </div>
    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Zone
        </span>
    </div>
    <div class="row rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col-12">
            <mat-label>Heure de prelevement</mat-label>
            <input matInput placeholder="Heure de prelevement" [ngxTimepicker]="timepicker1" [format]="24" [value]="TimeSampling" readonly>
            @if (TimeSampling) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSampling()">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
            }
            <ngx-material-timepicker #timepicker1 (timeSet)="timeSetSampling($event)" [defaultTime]="DefaultTime"></ngx-material-timepicker>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Date de dernier bionettoyage</mat-label>
            <input matInput placeholder="Date de dernier bionettoyage" [matDatepicker]="picker" [(ngModel)]="DateDerniereLavage" (click)="picker.open()"
                (dateChange)="dateDernierLavageChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Heure de bionettoyage</mat-label>
            <input matInput placeholder="Heure de bionettoyage" [ngxTimepicker]="timepicker2" [format]="24" [value]="TimeBionettoyage" readonly>
            @if (TimeBionettoyage) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearBionettoyage()">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
            }
            <ngx-material-timepicker #timepicker2 (timeSet)="timeSetBionettoyage($event)" [defaultTime]="DefaultTime"></ngx-material-timepicker>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Condition Prelevement</mat-label>
            <mat-select placeholder="Condition Prelevement" [(ngModel)]="Zone.ConditionPrelevement" required>
                @for (o of ConditionPrelevementList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    @if (Zone.PrelevementAirList.length > 0) {
    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Prélèvement d'air
        </span>
    </div>
    }
    @for (prel of Zone.PrelevementAirList; track prel; let j = $index) {
    <span>
        <div class="row rounded-1 background-light mb-3 py-3">
            <div class="text-center fw-bold mb-3">
                {{prel.Prelevement.SamplingPoint.Name}}
            </div>
            @if (prel.Prelevement.Comment) {
            <div class="text-center fst-italic mb-3">
                {{prel.Prelevement.Comment}}
            </div>
            }
            <mat-form-field class="col-12">
                <mat-label>Code OGI</mat-label>
                <input matInput [(ngModel)]="prel.Prelevement.OgiCode" placeholder="Code OGI" readonly>
            </mat-form-field>
            <mat-form-field class="col-12">
                <mat-label>Méthode Prelevement Air</mat-label>
                <mat-select placeholder="Méthode Prelevement Air" [(ngModel)]="prel.MethodePrelevementAir" required>
                    @for (o of MethodePrelevementAirList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <!-- <mat-form-field class="col-12">
          <mat-select placeholder="Lieu de Prélèvement" [(ngModel)]="prel.LieuPrelevement" required>
            <mat-option *ngFor="let o of LieuPrelevementAirList; let i = index" [value]="i + 1">
              <span>{{o}}</span>
            </mat-option>
          </mat-select>
        </mat-form-field> *ngIf="prel.LieuPrelevement === ELieuPrelevementAir.Autre"  -->
            <mat-form-field class="col-12">
                <mat-label>Lieu de Prélèvement si différent de Milieu de Salle</mat-label>
                <input matInput [(ngModel)]="prel.AutreLieuPrelevement" placeholder="Lieu de Prélèvement si différent de Milieu de Salle">
            </mat-form-field>
            <mat-form-field class="col-12">
                <mat-label>Volume air prélevé (L)</mat-label>
                <input matInput type="number" [(ngModel)]="prel.VolumeAirPreleve" placeholder="Volume air prélevé (L)">
            </mat-form-field>
            <mat-form-field class="col-12">
                <mat-label>Temps de Sédimentation (min)</mat-label>
                <input matInput type="number" [(ngModel)]="prel.TempsSedimentation" placeholder="Temps de Sédimentation (min)">
            </mat-form-field>
            <mat-form-field class="col-12">
                <mat-label>Type de milieu de prélèvement</mat-label>
                <mat-select placeholder="Milieu de Prélèvement" [(ngModel)]="prel.MilieuPrelevement" required>
                    @for (o of MilieuPrelevementList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field class="col-12">
                <mat-label>Observation</mat-label>
                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
                    [(ngModel)]="prel.Observations" placeholder="Observation"></textarea>
            </mat-form-field>
        </div>

        <!-- <div class="row">
            <span class="ms-3 display-6 fw-bold">
                Appareil
            </span>
        </div> -->
        <!-- <div class="row rounded-1 background-light mb-3 py-3">

            <mat-form-field class="col-12">
                <mat-label>Marque</mat-label>
                <mat-select placeholder="Marque" [(ngModel)]="prel.Biocollecteur.Marque" required>
                    @for (o of MarqueAppareilAirList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class="col-12">
                <mat-label>Modèle</mat-label>
                <mat-select placeholder="Modèle" [(ngModel)]="prel.Biocollecteur.Modele" required>
                    @for (o of ModeleAppareilAirList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class="col-12">
                <mat-label>Numéro Interne</mat-label>
                <input matInput [(ngModel)]="prel.Biocollecteur.NumeroInterne" placeholder="Numéro Interne">
            </mat-form-field>
        </div> -->

        <div class="row">
            <span class="ms-5 fw-bold">
                Flacons
            </span>
        </div>
        @if (prel.Prelevement.FlaconList.length > 0) {
        <div class="row rounded-1 mb-3 py-3 background-light">
            <div class="col-12">
                @for (flacon of prel.Prelevement.FlaconList; track flacon; let i = $index) {
                <div class="row">
                    <div class="col-6">{{flacon.Code}}</div>
                    <div class="col-6">{{getFlaskTypeLabel(flacon.Type)}}</div>
                    <button class="col-auto" matPrefix mat-icon-button aria-label="barcode">
                        <mat-icon class="material-symbols-outlined">qr_code_scanner</mat-icon>
                    </button>
                    <mat-form-field class="col">
                        <mat-label>Barcode</mat-label>
                        <input matInput [(ngModel)]="flacon.Barcode" placeholder="Barcode" (keydown)="checkBarCode($event, flacon.Barcode)"
                            (keyup)="checkBarCodeExistence(flacon.Code, flacon.Barcode, j, i, EServiceType.Air, prel.Prelevement.FlaconList.length);"
                            [readonly]="canBeDisabled(flacon)" [id]="'barcode'+EServiceType.Air+'-'+j+'-'+i">
                        @if (flacon.Barcode) {
                        <button matSuffix mat-icon-button aria-label="Clear" (click)="flacon.Barcode=''">
                            <mat-icon class="material-symbols-outlined">close</mat-icon>
                        </button>
                        }
                    </mat-form-field>
                </div>
                }
            </div>
        </div>
        }
        <div class="row">
            <span class="ms-5 fw-bold">
                Consommables
            </span>
        </div>
        <div class="row mb-3">
            <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button
                (throttledClick)="openConsommableBox(EServiceType.Air, prel.Prelevement, prel.MilieuPrelevement)">
                <mat-icon class="material-symbols-outlined">add</mat-icon>Ajouter
            </button>
        </div>
        @if (prel.Prelevement.ConsommableList.length > 0) {
        <div class="row rounded-1 mb-3 py-3 background-light">
            <div class="col-12">
                @for (cons of prel.Prelevement.ConsommableList; track cons; let i = $index) {
                <div class="row">
                    <div class="col-4 text-end">Type</div>
                    <div class="col-8">{{getConsommableAirLabel(cons.Type)}}</div>
                    <div class="col-4 text-end">Numéro Lot</div>
                    <div class="col-8">{{cons.NumeroLot}}</div>
                    <div class="col-4 text-end">Expiration</div>
                    <div class="col-8">{{cons.Expiration!.toLocaleString()}}</div>
                    <div class="col-12 text-end">
                        <button appPreventDoubleClick class="" color="primary" mat-icon-button
                            (throttledClick)="openConsommableBox(EServiceType.Air, prel.Prelevement, prel.MilieuPrelevement, cons)">
                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                        </button>
                        <button appPreventDoubleClick class="col-12" color="warn" mat-icon-button
                            (throttledClick)="deleteConsommable(cons, prel.Prelevement, EServiceType.Air)">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                    </div>
                </div>
                }
            </div>
        </div>
        }
    </span>
    }
    @if (Zone.PrelevementSurfaceList.length > 0) {
    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Prélèvement de surfaces
        </span>
    </div>
    }
    @for (prel of Zone.PrelevementSurfaceList; track prel; let j = $index) {
    <span>
        <div class="row rounded-1 background-light mb-3 py-3">
            <div class="text-center fw-bold mb-3">
                {{prel.Prelevement.SamplingPoint.Name}}
            </div>
            @if (prel.Prelevement.Comment) {
            <div class="text-center fst-italic mb-3">
                {{prel.Prelevement.Comment}}
            </div>
            }
            <mat-form-field class="col-12">
                <mat-label>Code OGI</mat-label>
                <input matInput [(ngModel)]="prel.Prelevement.OgiCode" placeholder="Code OGI" readonly>
            </mat-form-field>
            <!-- <mat-form-field class="col-12">
                <mat-select placeholder="Lieu de Prélèvement" [(ngModel)]="prel.LieuPrelevement" required>
                    @for (o of LieuPrelevementSurfaceList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field> -->
            <mat-form-field>
                <mat-label>Lieu de Prélèvement</mat-label>
                <input type="text" placeholder="Filtrer les lieux en entrant du texte" aria-label="Lieu de Prélèvement" matInput [matAutocomplete]="auto"
                    [(ngModel)]="prel.SearchText" (keyup)="filterLieuPrelevementList(prel)">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange(prel, $event)">
                    @for (option of filteredLieuPrelevementOptions ; track option) {
                    <mat-option [value]="option">{{option.s}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            @if (prel.LieuPrelevement === ELieuPrelevementSurface.Autre) {
            <mat-form-field class="col-12">
                <mat-label>Lieu de Prélèvement</mat-label>
                <input matInput [(ngModel)]="prel.AutreLieuPrelevement" placeholder="Lieu de Prélèvement">
            </mat-form-field>
            }
            <mat-form-field class="col-12">
                <mat-label>Milieu de Prélèvement</mat-label>
                <mat-select placeholder="Milieu de Prélèvement" [(ngModel)]="prel.MilieuPrelevement" required>
                    @for (o of MilieuPrelevementSurfaceList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field class="col-12">
                <mat-label>Observation</mat-label>
                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
                    [(ngModel)]="prel.Observations" placeholder="Observation"></textarea>
            </mat-form-field>
        </div>

        <div class="row">
            <span class="ms-5 fw-bold">
                Flacons
            </span>
        </div>
        @if (prel.Prelevement.FlaconList.length > 0) {
        <div class="row rounded-1 mb-3 py-3 background-light">
            <div class="col-12">
                @for (flacon of prel.Prelevement.FlaconList; track flacon; let i = $index) {
                <div class="row">
                    <div class="col-6">{{flacon.Code}}</div>
                    <div class="col-6">{{getFlaskTypeLabel(flacon.Type)}}</div>
                    <button class="col-auto" matPrefix mat-icon-button aria-label="barcode">
                        <mat-icon class="material-symbols-outlined">qr_code_scanner</mat-icon>
                    </button>
                    <mat-form-field class="col">
                        <mat-label>Barcode</mat-label>
                        <input matInput [(ngModel)]="flacon.Barcode" placeholder="Barcode" (keydown)="checkBarCode($event, flacon.Barcode)"
                            (keyup)="checkBarCodeExistence(flacon.Code, flacon.Barcode, j, i, EServiceType.Surface, prel.Prelevement.FlaconList.length)"
                            [readonly]="canBeDisabled(flacon)" [id]="'barcode'+EServiceType.Surface+'-'+j+'-'+i">
                        @if (flacon.Barcode) {
                        <button matSuffix mat-icon-button aria-label="Clear" (click)="flacon.Barcode=''">
                            <mat-icon class="material-symbols-outlined">close</mat-icon>
                        </button>
                        }
                    </mat-form-field>
                </div>
                }
            </div>
        </div>
        }
        <div class="row">
            <span class="ms-5 fw-bold">
                Consommables
            </span>
        </div>
        <div class="row mb-3">
            <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button
                (throttledClick)="openConsommableBox(EServiceType.Surface, prel.Prelevement, prel.MilieuPrelevement)">
                <mat-icon class="material-symbols-outlined">add</mat-icon>Ajouter
            </button>
        </div>
        @if (prel.Prelevement.ConsommableList.length > 0) {
        <div class="row rounded-1 mb-3 py-3 background-light">
            <div class="col-12">
                @for (cons of prel.Prelevement.ConsommableList; track cons; let i = $index) {
                <div class="row">
                    <div class="col-6">{{getConsommableSurfaceLabel(cons.Type)}}</div>
                    <div class="col-6">{{cons.NumeroLot}}</div>
                    <div class="col-6">{{cons.Expiration!.toLocaleString()}}</div>
                    <button appPreventDoubleClick class="col-12" color="warn" mat-icon-button
                        (throttledClick)="deleteConsommable(cons, prel.Prelevement, EServiceType.Surface)">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                </div>
                }
            </div>
        </div>
        }
    </span>
    }
    @if (Zone.PrelevementQualifSalle) {
    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Qualif de Salle
        </span>
    </div>
    <span>
        <div class="row rounded-1 background-light mb-3 py-3">

            @if (hasPlan(Zone.PrelevementQualifSalle.Plan)) {
            <div class="col-auto">
                <img class="w-100" [src]="Zone.PrelevementQualifSalle.Plan">
            </div>
            }
            <div class="text-center fw-bold mb-3">
                {{Zone.PrelevementQualifSalle.Prelevement.SamplingPoint.Name}}
            </div>
            <mat-form-field class="col-12">
                <mat-label>Code OGI</mat-label>
                <input matInput [(ngModel)]="Zone.PrelevementQualifSalle.Prelevement.OgiCode" placeholder="Code OGI" readonly>
            </mat-form-field>
            <mat-form-field class="col-12">
                <mat-label>Personnes Présentes (vide = annulation)</mat-label>
                <input matInput type="number" [(ngModel)]="Zone.PrelevementQualifSalle.PersonnesPresentes" placeholder="Personnes Présentes">
            </mat-form-field>

            <mat-form-field class="col-12">
                <mat-label>Système traitement d'air</mat-label>
                <mat-select placeholder="Système traitement d'air" [(ngModel)]="Zone.PrelevementQualifSalle.SystemeTraitementAir" required>
                    @for (o of SystemeTraitemenrAirList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <!-- @for (app of Zone.PrelevementQualifSalle.AppareilQualifList; track app; let i = $index) {

            <span class="display-6 fw-bold text-center">
                {{ app.Type === ETypeAppareilQualif.Compteur ? 'Compteur' : 'Multimètre'}}
            </span>

            @if (app.Type === ETypeAppareilQualif.Compteur) {
            <mat-form-field class="col-12">
                <mat-label>Marque</mat-label>
                <mat-select placeholder="Marque" [(ngModel)]="app.Marque" required>
                    @for (o of MarqueCompteurList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class="col-12">
                <mat-label>Modèle</mat-label>
                <mat-select placeholder="Modèle" [(ngModel)]="app.Modele" required>
                    @for (o of ModeleCompteurList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            } @else {
            <mat-form-field class="col-12">
                <mat-label>Marque</mat-label>
                <mat-select placeholder="Marque" [(ngModel)]="app.Marque" required>
                    @for (o of MarqueMultimetreList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class="col-12">
                <mat-label>Modèle</mat-label>
                <mat-select placeholder="Modèle" [(ngModel)]="app.Modele" required>
                    @for (o of ModeleMultimetreList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            }

            <mat-form-field class="col-12">
                <mat-label>Numéro Interne</mat-label>
                <input matInput [(ngModel)]="app.NumeroInterne" placeholder="Numéro Interne">
            </mat-form-field>
            } -->

            <mat-form-field class="col-12">
                <mat-label>Localisation de salle</mat-label>
                <mat-select placeholder="Localisation de salle" [(ngModel)]="Zone.PrelevementQualifSalle.LocalisationDeSalle" required>
                    @for (o of LocalisationSalleList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class="col-12">
                <mat-label>Classe</mat-label>
                <mat-select placeholder="Classe" [(ngModel)]="Zone.PrelevementQualifSalle.Classe" required>
                    @for (o of ClasseList; track o; let i = $index) {
                    <mat-option [value]="o.idx">
                        <span>{{o.s}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            @if (Zone.PrelevementQualifSalle.Type === EAirQFType.BPP) {
            <div class="col-12 my-3 text-center">
                <mat-slide-toggle class="col-auto" [(ngModel)]="Zone.PrelevementQualifSalle.ProduitDangereux">Produit dangereux pour l'environnement
                    ?</mat-slide-toggle>
            </div>
            }

            <mat-form-field class="col-6">
                <mat-label>Surface ZAC (m²)</mat-label>
                <input matInput type="number" [(ngModel)]="Zone.PrelevementQualifSalle.SurfaceZAC" placeholder="Surface ZAC (m²)" required>
                @if (Zone.PrelevementQualifSalle.SurfaceZAC! < 0) { <span class="error">
                    Ne peut être négatif
    </span>
    }
    </mat-form-field>

    <div class="col-6">
        @if (Zone.PrelevementQualifSalle.SurfaceZAC) {
        <mat-form-field class="w-100">
            <mat-label>Nombre de points</mat-label>
            <input matInput type="number" [ngModel]="calculerNombrePoints(Zone.PrelevementQualifSalle.SurfaceZAC)" placeholder="Nombre de points" readonly="">
        </mat-form-field>
        }
    </div>


    <mat-form-field class="col-12">
        <mat-label>Volume ZAC (m3)</mat-label>
        <input matInput type="number" [(ngModel)]="Zone.PrelevementQualifSalle.Volume" placeholder="Volume ZAC (m3)" required>
        @if (Zone.PrelevementQualifSalle.Volume! < 0) { <span class="error">
            Ne peut être négatif
            </span>
            }
    </mat-form-field>

    <mat-form-field class="col-12">
        <mat-label>Température (°C)</mat-label>
        <input matInput type="number" [(ngModel)]="Zone.PrelevementQualifSalle.Temperature" placeholder="Température  (°C)" required>
    </mat-form-field>

    <mat-form-field class="col-12">
        <mat-label>Humidité relative (%)</mat-label>
        <input matInput type="number" [(ngModel)]="Zone.PrelevementQualifSalle.Humidite" placeholder="Humidité relative (%)" required>
        @if (Zone.PrelevementQualifSalle.Humidite! < 0 || Zone.PrelevementQualifSalle.Humidite!> 100) {
            <span class="error">
                Saisir une valeur entre 0 et 100
            </span>
            }
    </mat-form-field>

    <mat-form-field class="col-12">
        <mat-label>Luminosité (Lux)</mat-label>
        <input matInput type="number" [(ngModel)]="Zone.PrelevementQualifSalle.Luminosite" placeholder="Luminosité (Lux)">
        @if (Zone.PrelevementQualifSalle.Luminosite! < 0) { <span class="error">
            Ne peut être négatif
            </span>
            }
    </mat-form-field>

    <mat-form-field class="col-12">
        <mat-label>Pression Acoustique (dB)</mat-label>
        <input matInput type="number" [(ngModel)]="Zone.PrelevementQualifSalle.PressionAcoustique" placeholder="Pression Acoustique (dB)">
        @if (Zone.PrelevementQualifSalle.PressionAcoustique! < 0) { <span class="error">
            Ne peut être négatif
            </span>
            }
    </mat-form-field>

    <mat-form-field class="col-12">
        <mat-label>Test Fumée</mat-label>
        <mat-select placeholder="Test Fumée" [(ngModel)]="Zone.PrelevementQualifSalle.TestFumee" required>
            @for (o of TestFumeeList; track o; let i = $index) {
            <mat-option [value]="i + 1">
                <span>{{o}}</span>
            </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Pourcentage d'air neuf</mat-label>
            <input matInput type="number" [(ngModel)]="Zone.PrelevementQualifSalle.PourcentageAirNeuf" placeholder="Pourcentage d'air neuf">
        </mat-form-field>
    </div>

    <mat-form-field class="col-12">
        <mat-label>Observation</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
            [(ngModel)]="Zone.PrelevementQualifSalle.Observations" placeholder="Observation"></textarea>
    </mat-form-field>
</div>
</span>
}

@if (Zone.PrelevementQualifSalle && Intervention?.Status !== EInterventionStatus.Preview && Zone.PrelevementQualifSalle.Type !==
EAirQFType.ComptageParticulaire) {
<div class="row">
    <span class="ms-3 display-6 fw-bold">
        Soufflages
    </span>
</div>
<div class="row rounded-1 background-light mb-3 py-3">
    <div class="col">

        @for (soufflage of Zone.PrelevementQualifSalle?.SoufflageList; track soufflage; let i = $index) {
        <div class="row rounded-1 align-items-center m-3 py-3 background">
            <div class="col-12 text-center">
                <h1><span class="badge rounded-pill text-bg-warning m-auto">{{i + 1}}</span></h1>
            </div>
            @if (soufflage.Largeur) {
            <div class="col-6 text-end fw-bold">Largeur</div>
            <div class="col-6"> {{soufflage.Largeur}} m</div>
            }
            @if (soufflage.Longueur) {
            <div class="col-6 text-end fw-bold">Longueur</div>
            <div class="col-6 ">{{soufflage.Longueur}} m</div>
            }
            <div class="col-6 text-end fw-bold">Surface</div>
            <div class="col-6">{{soufflage.Surface}} m²</div>
            <div class="col-6 text-end fw-bold">Vitesse</div>
            <div class="col-6">{{soufflage.Vitesse ?? 'N/A'}} m/s</div>
            <!-- <div class="col-6 text-end fw-bold">Pourcentage Air Neuf</div>
                    <div class="col-6">{{soufflage.PourcentageAirNeuf}}</div> -->

            <div class="col-12 text-end">
                <button appPreventDoubleClick class="" color="primary" mat-icon-button (throttledClick)="openSoufflageBox(soufflage)">
                    <mat-icon class="material-symbols-outlined">edit</mat-icon>
                </button>
                <button appPreventDoubleClick class="" color="warn" mat-icon-button (throttledClick)="deleteSoufflage(soufflage)">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
            </div>
        </div>
        }
        <div class="row m-2">
            <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button (throttledClick)="openSoufflageBox()">
                <mat-icon class="material-symbols-outlined">add</mat-icon>Ajouter
            </button>
        </div>
    </div>
</div>

<div class="row">
    <span class="ms-3 display-6 fw-bold">
        Reprises
    </span>
</div>
<div class="row rounded-1 background-light mb-3 py-3">

    <div class="col">


        @for (reprise of Zone.PrelevementQualifSalle?.RepriseList; track reprise; let i = $index) {
        <div class="row rounded-1 align-items-center m-3 py-3 background">
            <div class="col-12 text-center">
                <h1><span class="badge rounded-pill text-bg-success m-auto">{{i + 1}}</span></h1>
            </div>

            @if (reprise.Largeur) {
            <div class="col-6 text-end fw-bold">Largueur</div>
            <div class="col-6"> {{reprise.Largeur}} m</div>
            }
            @if (reprise.Longueur) {
            <div class="col-6 text-end fw-bold">Longueur</div>
            <div class="col-6 ">{{reprise.Longueur}} m</div>
            }
            <div class="col-6 text-end fw-bold">Surface</div>
            <div class="col-6">{{reprise.Surface}} m²</div>
            <div class="col-6 text-end fw-bold">Vitesse</div>
            <div class="col-6">{{reprise.Vitesse ?? 'N/A'}} m/s</div>

            <div class="col-12 text-end">
                <button appPreventDoubleClick class="" color="primary" mat-icon-button (throttledClick)="openRepriseBox(reprise)">
                    <mat-icon class="material-symbols-outlined">edit</mat-icon>
                </button>
                <button appPreventDoubleClick class="" color="warn" mat-icon-button (throttledClick)="deleteReprise(reprise)">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
            </div>
        </div>
        }
        <div class="row m-2">
            <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button (throttledClick)="openRepriseBox()">
                <mat-icon class="material-symbols-outlined">add</mat-icon>Ajouter
            </button>
        </div>
    </div>
</div>

<div class="row">
    <span class="ms-3 display-6 fw-bold">
        Mesure du différentiel de pression intérieur
    </span>
</div>
<div class="row rounded-1 background-light mb-3 py-3">
    <div class="col">


        @for (zoneCompare of Zone.PrelevementQualifSalle?.ZoneAComparerList; track zoneCompare; let i = $index) {
        <div class="row rounded-1 align-items-center m-3 py-3 background">

            <div class="col-12 text-center">
                <h1><span class="badge rounded-pill text-bg-info m-auto">{{i + 1}}</span></h1>
            </div>
            <div class="col-6 text-end fw-bold">Nom</div>
            <div class="col-6"> {{zoneCompare.Name}}</div>
            <div class="col-6 text-end fw-bold">Différentiel de Pression (Pa)</div>
            <div class="col-6 ">{{zoneCompare.DifferentielPression}}</div>

            <div class="col-12 text-end">
                <button appPreventDoubleClick class="" color="primary" mat-icon-button (throttledClick)="openZoneCompareBox(false, zoneCompare)">
                    <mat-icon class="material-symbols-outlined">edit</mat-icon>
                </button>
                <button appPreventDoubleClick class="" color="warn" mat-icon-button (throttledClick)="deleteZoneAComparer(zoneCompare, false)">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
            </div>
        </div>
        }
        <div class="row m-2">
            <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button (throttledClick)="openZoneCompareBox(false)">
                <mat-icon class="material-symbols-outlined">add</mat-icon>Ajouter
            </button>
        </div>
    </div>
</div>

@if (Zone.PrelevementQualifSalle.Type === EAirQFType.BPP) {
<div class="row">
    <span class="ms-3 display-6 fw-bold">
        Mesure du différentiel de pression SAS
    </span>
</div>
<div class="row rounded-1 background-light mb-3 py-3">
    <div class="col">

        <div class="row m-2">
            <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button (throttledClick)="openZoneCompareBox(true)">
                <mat-icon class="material-symbols-outlined">add</mat-icon>Ajouter
            </button>
        </div>
        @for (zoneCompare of Zone.PrelevementQualifSalle?.ZoneAComparerSasList; track zoneCompare; let i = $index) {
        <div class="row rounded-1 align-items-center m-3 py-3 background">

            <div class="col-12 text-center">
                <h1><span class="badge rounded-pill text-bg-info m-auto">{{i + 1}}</span></h1>
            </div>
            <div class="col-6 text-end fw-bold">Nom</div>
            <div class="col-6"> {{zoneCompare.Name}}</div>
            <div class="col-6 text-end fw-bold">Différentiel de Pression (Pa)</div>
            <div class="col-6 ">{{zoneCompare.DifferentielPression}}</div>

            <div class="col-12 text-end">
                <button appPreventDoubleClick class="" color="primary" mat-icon-button (throttledClick)="openZoneCompareBox(true, zoneCompare)">
                    <mat-icon class="material-symbols-outlined">edit</mat-icon>
                </button>
                <button appPreventDoubleClick class="" color="warn" mat-icon-button (throttledClick)="deleteZoneAComparer(zoneCompare, true)">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
            </div>
        </div>
        }
    </div>
</div>
}
}

@if (!Zone.PrelevementQualifSalle && Intervention?.Status !== EInterventionStatus.Preview) {
<div class="row mb-3">
    <button appPreventDoubleClick class="col-12" color="warn" mat-raised-button (throttledClick)="cleanAllBarcodes()">
        Effacer les codes à barres
    </button>
</div>
}

@if (Intervention?.Status !== EInterventionStatus.Preview) {
<div class="row mb-3">
    <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button (throttledClick)="showAlert(false)">
        Enregistrer
    </button>
</div>
<div class="row mb-3">
    <button appPreventDoubleClick class="col-12" color="accent" mat-raised-button (throttledClick)="showAlert(true)">
        Terminer et Enregistrer
    </button>
</div>
}
</div>
}